<template>
  <AppWithLoading :fetch="fetchAndPush" />
</template>

<script>
import AppWithLoading from '../components/AppWithLoading.vue';

export default {
  name: 'DemoInterviewFetcher',
  components: { AppWithLoading },
  props: {
    lang: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      demoVacancy: null,
    };
  },
  methods: {
    async fetchAndPush() {
      this.demoVacancy = await this.$store.dispatch('vacancy/fetchDemoVacancyByLocale', this.lang);
      await this.$router.push(
        {
          name: 'vacancyReply',
          params: {
            companyId: this.demoVacancy.companyId,
            vacancyId: this.demoVacancy.vacancyId,
          },
        },
      );
    },
  },
};
</script>

<style scoped>

</style>
